export function BlogKeyTakeaway({ text }: { text: string }) {
  if (!text?.trim()) return null;
  return (
    <div
      role="note"
      aria-label="Key takeaway"
      className="not-prose mb-10 rounded-3xl border border-border bg-card p-6 sm:p-8 shadow-sm relative overflow-hidden"
    >
      <span
        aria-hidden="true"
        className="absolute left-0 top-0 bottom-0 w-1.5 bg-primary"
      />
      <p className="text-caption font-semibold uppercase tracking-wide text-primary mb-2">
        Key takeaway
      </p>
      <p className="text-lg text-foreground leading-relaxed">{text}</p>
    </div>
  );
}